import SavedTeamsSection from '../../components/saved-teams-section.tsx';
import { TeamSettingsFrame } from './team-hub.tsx';

/** /settings/team/saved: the crews a visit can be booked to. */
export default function TeamSavedPage() {
  return (
    <TeamSettingsFrame current="saved">
      <SavedTeamsSection />
    </TeamSettingsFrame>
  );
}
